export function show_carusel($) {
  $('.quotes-component__slider').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: true,
    prevNextButtons: false,
    initialSlide: 1,
    centerMode: true,
    focusOnSelect: true,
    adaptiveHeight: true,
    //cssEase: 'linear',
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 1,
          adaptiveHeight: false,
        }
      }
    ],
  });
}
